import { render, staticRenderFns } from "./ThresholdLimitModal.vue?vue&type=template&id=3a0b195a&scoped=true"
import script from "./ThresholdLimitModal.vue?vue&type=script&lang=ts"
export * from "./ThresholdLimitModal.vue?vue&type=script&lang=ts"
import style0 from "./ThresholdLimitModal.vue?vue&type=style&index=0&id=3a0b195a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0b195a",
  null
  
)

export default component.exports